import React, { useState } from 'react';
import { Form, Input, Upload, Button, message, Breadcrumb, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axiosInstance';
import { convertIntoFormData } from '../../utils/utils';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

const { TextArea } = Input;
export default function AddEsign() {
    const ids = useSelector((store) => store.auth.userInfo);
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const compnayID = localStorage.getItem("companyId") ;

    const onFinish = async (values) => {
        try {
            setIsLoading(true)
            const fileObj = values.execution_file[0].originFileObj;
            console.log(fileObj, 'fileObj')
            values.execution_file = fileObj;
            values.created_user = ids?.user_id;
            values.company = compnayID || ids?.company_id;
            const payload = convertIntoFormData(values)
            const res = await axiosInstance.post(`/agreements/create/`, payload)
            const getEsignUrl = await axiosInstance.post(`/esign/document/`, { agreement_id: res?.data?.id })
            window.open(getEsignUrl?.data?.redirect_url, "_blank", "noreferrer");
            navigate( compnayID ? `/admin/company/${compnayID}/esign` : "/admin/esign");
            message.success('Form submitted successfully!');
        } catch (error) {
            console.log(error)
            message.error(error?.response?.data?.error)
        } finally {
            setIsLoading(false)
        }
    };

    return (
        <>
            <div className=" mb-4 sticky -top-6 bg-white z-10 shadow-sm p-4 dark:bg-[#17153B] border-b">
                <Breadcrumb className="text-lg font-medium text-gray-700">
                    <Breadcrumb.Item>
                        <Link to="/admin/esign" className="hover:text-blue-600 transition-colors">
                            Esign
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="text-blue-500 font-semibold">Add Esign</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <Spin spinning={isLoading}>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className='dark:bg-[#17153B] bg-[#f5f5f5]'
                    style={{
                        maxWidth: 600,
                        margin: 'auto',
                        border: '1px solid #d9d9d9',
                        padding: '24px',
                        borderRadius: '8px',
                        // backgroundColor: '#f5f5f5', // light gray
                    }}
                >
                    {/* Partner Name */}
                    <Form.Item
                        label="Partner Name"
                        name="party_name"
                        rules={[{ required: true, message: 'Please enter partner name' }]}
                    >
                        <Input placeholder="Enter partner name" />
                    </Form.Item>

                    {/* Entity */}
                    <Form.Item
                        label="Entity"
                        name="entity_name"
                        rules={[{ required: true, message: 'Please enter entity' }]}
                    >
                        <Input placeholder="Enter entity type" />
                    </Form.Item>

                    <Form.Item
                        label="Nature"
                        name="nature"
                        rules={[{ required: true, message: 'Please enter nature' }]}
                    >
                        <Input placeholder="Enter entity type" />
                    </Form.Item>

                    {/* Document Type */}
                    <Form.Item
                        label="Document Type"
                        name="document_type"
                        rules={[{ required: true, message: 'Please enter document type' }]}
                    >
                        <Input placeholder="Enter document type" />
                    </Form.Item>

                    {/* Description */}
                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: true, message: 'Please enter a description' }]}
                    >
                        <TextArea placeholder="Enter description..." rows={4} />
                    </Form.Item>

                    {/* File Upload */}
                    <Form.Item
                        label="Upload Document"
                        name="execution_file"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => Array.isArray(e) ? e : e?.fileList}
                        rules={[{ required: true, message: 'Please upload a document' }]}
                    >
                        <Upload name="file" beforeUpload={() => false} maxCount={1}>
                            <Button icon={<UploadOutlined />}>Click to Upload</Button>
                        </Upload>
                    </Form.Item>

                    {/* Submit */}
                    <Form.Item>
                        <Button loading={isLoading} type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>
        </>

    );
};
